import { Component, Input, OnInit } from '@angular/core';
import { PaysService } from '../services/pays.service';

@Component({
  selector: 'partner-image',
  template: `

    <img *ngIf="imageUrl" [src]="imageUrl" alt="" class="w-6rem h-6rem flex-shrink-0" />

  `,
  styles: []
})
export class PartnerImageComponent {
  imageUrl: string | null = null;

  constructor(private paysService:PaysService) { }

  ngOnInit(): void {
    this.loadImage();
  }

  loadImage(): void {
    this.paysService.getlogo().subscribe({
      next:(imageBlob: Blob | null)=>{
        if (imageBlob) {
          this.imageUrl = URL.createObjectURL(imageBlob);
        }
      }
    });
  }
}
